// extracted by mini-css-extract-plugin
module.exports = {"field":"W04mu","label":"XuuL+","value":"p-oMT"};